import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import CallforPapers from "./pages/CallforPapers/CallforPapers";
import Committee from "./pages/Committee/Committee";
import ForAuthors from "./pages/ForAuthors/ForAuthors";
import SpecialSessions from "./pages/SpecialSessions/SpecialSessions";
import Main from "./pages/Main";
import FessandDates from "./pages/FessandDates";
import RegistrationForm from "./pages/RegistrationForm/RegistrationForm";
import Acknowledge from "./components/Acknowledge";
import Login from "./pages/Login/Login";
import { AuthContext } from "./context/AuthContext";
import { useContext } from "react";
import OrganizerPortal from "./pages/OrganizerPortal/OrganizerPortal";
import Payments from './pages/payments/Payments.jsx'
import ProgramSchedule from "./pages/ProgramSchedule/ProgramSchedule.jsx";

function App() {
  const RequireAuth = ({ children }) => {
    const { currentUser } = useContext(AuthContext);
    return currentUser ? children : <Navigate to="/organizer/login" />
  };
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route path="/keydates&fees" element={<FessandDates />} />
          <Route path="/committes" element={<Committee />} />
          <Route path="/forauthors" element={<ForAuthors />} />
          <Route path="/callforpapers" element={<CallforPapers />} />
          <Route path="/specialsessions" element={<SpecialSessions />} />
          <Route path="/programschedule" element={<ProgramSchedule />} />
          <Route path="/registrationform" element={<RegistrationForm />} />
          <Route path="/acknowledge" element={<Acknowledge />} />
          <Route path="/organizer/login" element={<Login />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/organizer/dashboard" element={<RequireAuth><OrganizerPortal /></RequireAuth>} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
